import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _AddRingFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-8 1v4h-2v-4H7v-2h4V7h2v4h4v2z", clipRule: "evenodd" })));
}
const AddRingFill = forwardRef(_AddRingFill);
export { AddRingFill };
